'use client';

import clsx from 'classnames';
import * as React from 'react';
import { useRef } from 'react';
import { Trans } from 'react-i18next';

import { useTranslation } from '@/i18n/client';
import { Image } from '@/shared/components/image';

import styles from './PaymentsTable.module.scss';
import { PaymentsTableProps } from './types';
import { imageBreakpoints } from './utils';

export const PaymentsTable = ({ rows }: PaymentsTableProps) => {
  const { t } = useTranslation(['payments', 'common']);
  const upperScrollRef = useRef<HTMLDivElement>(null);
  const bottomScrollRef = useRef<HTMLDivElement>(null);

  const descriptions: Record<string, React.ReactNode> = {
    // slovakia
    'bezny-bankovy-prevod': (
      <Trans i18nKey="table.bankPayment" t={t} components={[<br key={0} />]} />
    ),
    'kartou-online': t('table.cardPayment'),
    'na-dobierku': t('table.collectPayment'),
    'online-prevod-gopay': t('table.goPaySk'),
    // czech republic
    'bezny-bankovni-prevod': (
      <Trans i18nKey="table.bankPayment" t={t} components={[<br key={0} />]} />
    ),
    // 'kartou-online': t('table.cardPayment'),
    dobirka: t('table.collectPayment'),
    'rychly-online-prevod-gopay': t('table.goPayCz'),
    'google-pay': t('table.googlePay'),
    'apple-pay': t('table.applePay'),

    'szybki-przelew-payu': t('table.payU'),
    'za-pobraniem': t('table.collectPayment'),
    'karta-w-paczkomacie': t('table.cardInPaczkomat'),
    'przelew-tradycyjny': (
      <Trans i18nKey="table.bankPayment" t={t} components={[<br key={0} />]} />
    ),
    'przelew-online': t('table.tPay'),
    'karta-platnicza': t('table.cardPayment'),
    paypo: t('table.payPo'),
    blik: t('table.blik'),
    pobranie: t('table.collectPayment'),
  };

  const horizontalScrollSync = (
    event: React.UIEvent<HTMLDivElement>,
    oppositeRef: React.RefObject<HTMLDivElement>
  ) => {
    if (!oppositeRef.current) {
      return;
    }
    oppositeRef.current.scrollLeft = event.currentTarget.scrollLeft;
  };

  return (
    <div className={styles['SimpleTable']}>
      <div
        className={styles['SimpleTable__table-fake-wrapper']}
        onScroll={(event) => horizontalScrollSync(event, bottomScrollRef)}
        ref={upperScrollRef}
      >
        <div className={styles['SimpleTable__table-scroll-top']} />
      </div>
      <div
        className={styles['SimpleTable__table-wrapper']}
        onScroll={(event) => horizontalScrollSync(event, upperScrollRef)}
        ref={bottomScrollRef}
      >
        <table className={styles['SimpleTable__table']}>
          <tbody>
            <tr>
              <th>{t('breadcrumbs.paymentsMethods')}</th>
              <th className={styles['SimpleTable__table--center-align']}>
                {t('common:common.cost')}
              </th>
              <th className={styles['SimpleTable__table--center-align']}>
                {t('common:common.serviceDescription')}
              </th>
            </tr>
            {rows.map((item, index) => (
              <tr key={index}>
                <td className={styles['SimpleTable__table--title']}>
                  <div className={styles['SimpleTable__table--title-cell']}>
                    <Image
                      alt={`${item.title}`}
                      title={`${item.title}`}
                      breakpoints={imageBreakpoints}
                      src={item.imageUrl}
                      loader={false}
                    />
                    {item.title}
                  </div>
                </td>
                <td
                  className={clsx(
                    styles['SimpleTable__table--center-align'],
                    styles['SimpleTable__table--thin']
                  )}
                >
                  {item.cost}
                </td>
                <td>{descriptions[item.paymentCode]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
